import {useQuery} from 'react-query'
import {OptionEditModalForm} from './OptionEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialOption } from '../core/_models'

const OptionEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: Option,
    error,
  } = useQuery(
    `${QUERIES.OPTION_LIST}-Option-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/options")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <OptionEditModalForm isOptionLoading={isLoading} Option={{...initialOption, _id: undefined}} />
  }

  if (!isLoading && !error && Option) {
    return <OptionEditModalForm isOptionLoading={isLoading} Option={Option} />
  }

  return null
}

export {OptionEditModalFormWrapper}
